import { BackendResponseMapper } from '@infrastructure/axios/error';
import { HttpPostRequest } from '@infrastructure/axios/http-post-request';
import { ChangePasswordPayload, IChangePasswordUseCase, PasswordChanged } from '../../interfaces';

export default class ChangePasswordUseCase extends HttpPostRequest<ChangePasswordPayload, PasswordChanged> implements IChangePasswordUseCase {
  static readonly INVALID_PASSWORD = 'INVALID_PASSWORD';

  public async execute(payload: ChangePasswordPayload): Promise<PasswordChanged> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve((await this.dispatch('/auth/change-password', payload)).data.data);
      } catch (error) {
        reject(BackendResponseMapper.from(error));
      }
    });
  }
}
